<!-- Button -->
<div class="" *ngIf="AUTH.user$ | async as user">
  <button
    name="user"
    class="icon-button"
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="avatar">
      <img
        class="bg-center object-contain"
        [src]="user.picture"
        alt="profile" />
      <span class="status" [ngClass]="'online'"></span>
    </span>
  </button>

  <mat-menu
    class="user-actions-menu"
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
      <span class="user-info">
        <span>{{ 'Sign in' | translate }}</span>
        <span class="email">{{ user.email }}</span>
      </span>
    </button>

    <!-- <button mat-menu-item routerLink='/events'>
	        <mat-icon class="icon-size-17 fa-regular fa-window" matTooltip="{{ 'SHARED.spaces' | translate }}"></mat-icon>
	        {{'SHARED.spaces' | translate}}
	    </button> -->

    <!-- <app-languages [navbar]='true'></app-languages> -->

    <!-- <button mat-menu-item routerLink='/{{subdomain}}/{{eventurl}}/setup/users/profile/my' *ngIf="event">
	        <mat-icon class="icon-size-17 fa-regular fa-user" matTooltip="{{ 'SHARED.profile_information' | translate }}"></mat-icon>
	        <span>{{ 'SHARED.profile_information' | translate }}</span>
	    </button> -->
    <!--<button mat-menu-item routerLink="/login/change-password">
	        <mat-icon [svgIcon]="'feather:key'"></mat-icon>
	        <span>Change Password</span>
	    </button>-->
    <!--<button mat-menu-item>
	        <mat-icon [svgIcon]="'settings'"></mat-icon>
	        <span>Settings</span>
	    </button>-->
    <!--<button mat-menu-item [matMenuTriggerFor]="userStatus">
	        <mat-icon [svgIcon]="'radio_button_unchecked'"></mat-icon>
	        <span>Status</span>
	    </button>-->

    <!-- <button mat-menu-item>
				<mat-icon class="icon-size-17 fa-regular fa-moon-cloud" matTooltip="{{ 'Dark mode' | translate }}"></mat-icon>
				<span class="mr-3">Dark mode</span>
				<mat-slide-toggle [color]="'primary'" (change)="updateTheme($event)"></mat-slide-toggle>
		</button> -->

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon
        class="icon-size-17 fa-regular fa-arrow-right-from-bracket"
        matTooltip="{{ 'Disconnect' | translate }}"></mat-icon>
      <span>{{ 'Disconnect' | translate }}</span>
    </button>
  </mat-menu>

  <mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
      <span class="status online"></span>
      <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
      <span class="status away"></span>
      <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
      <span class="status busy"></span>
      <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
      <span class="status not-visible"></span>
      <span>Invisible</span>
    </button>
  </mat-menu>
</div>
